import { createFileRoute } from '@tanstack/react-router';

interface ArtistClaimSearch {
  artwork?: string;
}

export const Route = createFileRoute('/artist-claim')({
  validateSearch: (search: Record<string, unknown>): ArtistClaimSearch => ({
    artwork: typeof search.artwork === 'string' ? search.artwork : undefined,
  }),
});
